/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {createRoot} from 'react-dom/client';

import {ImmersiveOnboarding} from './immersive-onboarding';
import {AppContextProvider} from './context-wrapper';

const IMMERSIVE_ROOT = `immersive-onboarding-root`;

export const initImmersiveOnboarding = () => {
  let immersiveRoot = document.getElementById(IMMERSIVE_ROOT);

  if (immersiveRoot) {
    document.dispatchEvent(new CustomEvent(`onImmersiveOnboardingInit`));
    return;
  }

  const modalsNode = document.getElementById(`modals`);
  immersiveRoot = document.createElement(`div`);
  immersiveRoot.setAttribute(`id`, IMMERSIVE_ROOT);
  modalsNode?.appendChild(immersiveRoot);

  const root = createRoot(immersiveRoot);
  root.render(
    <AppContextProvider>
      <ImmersiveOnboarding />
    </AppContextProvider>,
  );
};
